import {getLocalUser,setLocalUser,getCompany,saveCompany} from '@/config/cache';
const state = {
  token: null, // token
  userInfo: getLocalUser(), // 用户登录信息
  companyInfo:getCompany(),//当前公司id
}

const mutations = {
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  CHANGE_COMPANY:(state,value)=>{
    state.companyInfo = value
  }
}

const actions = {
  // 登录相关，通过code获取token和用户信息，用户根据自己的需求对接后台
  saveUserInfo({commit}, value) {
    setLocalUser(value);
    commit('SET_USERINFO', value)
  },
  saveToken({commit},value)
  {
    commit('SET_TOKEN', value)
  },
  changeCompany({commit},value)
  {
    commit('CHANGE_COMPANY',value)
    saveCompany(value);

  },
  // 登出
  fedLogOut() {
    // 删除token，用户信息，登陆状态
    removeToken()
    removeUserInfo()
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
